import { makeAutoObservable } from "mobx";
import { AttributeShelf, LoaderShelf } from "../../shelves";
import { api } from "../../services";
import type { AuthenticationStore } from "../Authentication";
import type { ReasonsCode } from "../../enum";
import type { DocumentosCopyBiometryAnalysisStatus, KYCBiometryAnalysisStatus } from "../../enum";

export class FraudAnalysisStore {
	public loader = new LoaderShelf();
	public userOnboardURL = new AttributeShelf("");
	public kycStatus = new AttributeShelf<KYCBiometryAnalysisStatus | null>(null);
	public documentosCopy = new AttributeShelf<DocumentosCopyBiometryAnalysisStatus | null>(null);
	public reasonStatus = new AttributeShelf<ReasonsCode | null>(null);

	constructor(public authentication: AuthenticationStore) {
		makeAutoObservable(this);
	}

	// retorna se está carregando
	public get isLoading(): boolean {
		return this.loader.isLoading;
	}

	// retorna o status da análise de fraude KYC
	public get statusAnalysis(): KYCBiometryAnalysisStatus | null {
		return this.kycStatus.value;
	}

	// retorna o status da análise de fraude DocumentosCopy
	public get statusDocumentosCopy(): DocumentosCopyBiometryAnalysisStatus | null {
		return this.documentosCopy.value;
	}

	// retorna o motivo do status da análise de fraude
	public get statusReason(): ReasonsCode | null {
		return this.reasonStatus.value;
	}

	// Faz GET na api para pegar os dados de análise de fraude
	public getFraudAnalysis = async (): Promise<void> => {
		if (this.loader.isLoading) {
			return;
		}

		this.loader.start();

		try {
			const { data, links } = await api.getFraudAnalysis(this.authentication.getToken() || "");

			this.kycStatus.set(data.kyc.status);
			this.documentosCopy.set(data.documentoscopy.status);

			if (links && links[0].href) {
				this.userOnboardURL.set(links[0].href);
			}

			if (data.documentoscopy.reasonsCode) {
				this.reasonStatus.set(data.documentoscopy.reasonsCode[0].code);
			}
		} catch (e) {
			console.error(e);
			return;
		} finally {
			this.loader.end();
		}
	};

	// Faz POST na api para enviar os dados de análise de fraude
	public postFraudAnalysis = async (): Promise<void> => {
		if (this.loader.isLoading) {
			return;
		}

		this.loader.start();

		try {
			await api.postFraudAnalysis(this.authentication.getToken() || "", "FGTS");

			await this.getFraudAnalysis();
		} catch (e) {
			console.error(e);
			return;
		} finally {
			this.loader.end();
		}
	};
}
